import { LoanConditionalOptions } from 'prequalificationV2/components/Offers/offers.enums';

export const LOAN_OPTIONS_NAMES = [
  LoanConditionalOptions.FixedRates,
  LoanConditionalOptions.NoPrepaymentPenalty,
  LoanConditionalOptions.NoEquityAndNoAppraisal,
  LoanConditionalOptions.QuickFunding,
  LoanConditionalOptions.DirectToConsumerFunded,
  LoanConditionalOptions.AutopayMayImpact,
];
